export { Tabs } from './Tabs.component.jsx';
